import React from "react";
import checkIcon from "assets/icons/checkIcon.svg";
import ideaIcon from "assets/icons/idea.svg";
import emailIcon from "assets/icons/email.svg";
import { MobileViewBtns } from "./mobileViewBtns";

interface Props {
  onCopy: () => void;
  onGmailShare: () => void;
  policyData: any;
  addText?: string;
}

export const OurAdvice: React.FC<Props> = ({ onCopy, onGmailShare, policyData, addText }) => {
  const textStyle = `font-nunito font-medium text-[15px] leading-[20px] line-clamp-3`;
  return (
    <div className="hidden md:flex md:flex-col xl:flex-row 2xl:flex-row items-center justify-between gap-4 my-6 w-full border-dashed border-[2px] border-gray-300 rounded-lg">
      {/* Left Section */}
      <div className="flex gap-2 flex-shrink-0 py-2 pl-8 bg-[#F2F2F6] xl:bg-transparent w-full xl:w-auto items-center rounded-t-lg">
        <img src={checkIcon} alt="check" className="w-5 h-5" />
        <span className="font-extrabold text-xl">Our Advice</span>
      </div>

      {/* Right Section */}
      <div className="flex flex-col sm:flex-row gap-4 lg:py-4 pb-4 px-4 sm:pl-4">
        <div className="flex items-center gap-3 max-w-full sm:max-w-xs lg:ml-4">
          <img src={ideaIcon} alt="idea" className="w-8 md:w-11 h-auto flex-shrink-0" />
          <div className="max-w-[260px]">
            <p className={textStyle + " tracking-[-0.7px]"}>Protect yourself by notifying your insurance company of any discrepancies in your policy for a smooth claim experience.</p>
          </div>
        </div>

        <div className="flex items-center gap-3 max-w-full sm:max-w-xs lg:ml-4">
          <img src={emailIcon} alt="email" className="w-8 md:w-11 h-auto flex-shrink-0" />
          <div className="max-w-[260px]">
            <p className={textStyle}>
              Send the correct information to your insurer using your <span className="font-bold">Registered Email ID.</span> {addText}
            </p>
          </div>
        </div>
      </div>

      {/* Mobile view buttons */}
      {policyData?.ResultTitle !== "Healthy" && <MobileViewBtns onCopy={onCopy} onGmailShare={onGmailShare} className="2xl:hidden xl:hidden" />}
    </div>
  );
};
